<template>
  <div class="affiliate-select-box">
    <v-select
        v-model="model"
        :multiple="multiple || selectProps.multiple"
        :options="computedAffiliateOptions"
        label="company"
        :reduce="(affiliate) => affiliate.id"
        v-bind="selectProps"
        :chips="false"
        :clearable="clearable"
        :close-on-select="!(multiple || selectProps.multiple)"
        :deselect-from-dropdown="true"
    >
      <!-- ✅ Dropdown header with Select/Unselect buttons -->
      <template #list-header>
        <div
            v-if="multiple || selectProps.multiple"
            class="dropdown-actions d-flex justify-content-between align-items-center px-2 py-1"
        >
          <b-button
              size="sm"
              variant="outline-success"
              class="action-btn"
              @mousedown.stop.prevent="selectAll"
          >
            Select All
          </b-button>
          <b-button
              size="sm"
              variant="outline-danger"
              class="action-btn"
              @mousedown.stop.prevent="unselectAll"
          >
            Unselect All
          </b-button>
        </div>
        <hr class="m-1" />
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'AffiliateSelectBox',
  props: {
    value: { required: true },
    acronym: { default: () => false },
    multiple: { type: Boolean, default: () => false },
    nullable: { type: Boolean, default: () => true },
    clearable: { type: Boolean, default: () => false },
    selectProps: { type: Object, default: () => ({}) },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    computedAffiliateOptions() {
      const affiliates = this.$store.getters['data/allAffiliates'] || [];
      const enableNullable = this.nullable || this.selectProps.nullable;
      if (enableNullable) {
        return [{ id: null, company: 'NOT ASSIGNED' }, ...affiliates];
      }
      return affiliates;
    },
  },
  methods: {
    selectAll() {
      const allIds = this.computedAffiliateOptions
          .filter((opt) => opt.id !== null)
          .map((opt) => opt.id);
      this.$nextTick(() => this.$emit('input', allIds));
    },
    unselectAll() {
      this.$nextTick(() => this.$emit('input', []));
    },
  },
};
</script>

<style scoped>
.dropdown-actions {
  position: sticky;
  top: 0;
  z-index: 5; /* higher than options */
  background-color: #fff; /* ensures options don't bleed through */
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
}

/* dark theme fix */
.dark-layout .dropdown-actions {
  background-color: rgb(30, 31, 36);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.action-btn {
  min-width: 90px;
  font-size: 0.75rem;
}

</style>
